import React, { useEffect } from 'react';
import block from 'bem-cn';
// import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Select from 'components/Select/desktop';
import Button from 'components/Button';
import InputDate from 'components/InputDate/desktop';
import CheckBox from 'components/CheckBox';

import DaysFilter from 'features/reports/view/desktop/DaysFilter';
import { searchInItems } from 'features/reports/data';

import { actions as treeActions } from 'features/tree';

import SearchUserInput from 'components/SearchUserInput/SearchUserInput';

import './FilterBlock.scss';

const b = block('filter-block-cash');

const FilterBlock = ({
  isMobile,
  // count,
  // currentPage,
  // onPageClick,
  // isOnlyTotal,
  // setIsOnlyTotal,

  date,
  activeDay,
  onChangeBeginDate,
  onChangeEndDate,
  onChangeActiveDay,

  isDirectOnly,
  setIsDirectOnly,
  isHigher,
  setIsHigher,
  isDeposit,
  setIsDeposit,
  isWithdrawal,
  setIsWithdrawal,
  isBonus,
  setIsBonus,

  filters,
  setFilters,
  handleSearchInChange,

  filterValue,
  handleSearchChange,
  searchResult,
  isLoadingSearchResult,
  handleResultClick,

  onClickSearch,
}) => {
  const locale = useSelector(state => state.locale.locale);
  const dispatch = useDispatch();
  const locationRouter = useLocation();

  const user = new URLSearchParams(locationRouter.search).get('username') ?? '';
  const role = new URLSearchParams(locationRouter.search).get('role') ?? '';

  useEffect(() => {
    dispatch(treeActions.setSearchTree(''));
  }, [dispatch]);

  useEffect(() => {
    setFilters(prev => ({
      ...prev,
      user: user || filterValue,
      role: searchInItems.find(item => item.value === role) ?? searchInItems[0],
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onResultClick = username => {
    setFilters(prev => ({ ...prev, user: username }));
    handleResultClick(username);
  };

  const handleFormSubmit = e => {
    e.preventDefault();
    onClickSearch();
  };

  const handleKeyDown = e => {
    if (e?.key === 'Enter') {
      e.preventDefault();
      onClickSearch();
    }
  };

  return (
    <form className={b()} onSubmit={handleFormSubmit} onKeyDown={handleKeyDown} tabIndex={0}>
      <div className={b('header')}>{locale.filter}</div>

      <div className={b('top')}>
        <DaysFilter activeDay={activeDay} setActiveDay={onChangeActiveDay} isMobile={isMobile} />
        <div className={b('or')}>{locale.or}</div>
        <div className={b('date')}>
          <div className={b('date-row')}>
            <div className={b('title')}>{locale.dateFrom}</div>
            <div className={b('date-input')}>
              <InputDate showTimeSelect selected={date.beginDate} onChange={onChangeBeginDate} />
            </div>
          </div>
          <div className={b('date-row')}>
            <div className={b('title')}>{locale.dateTo}</div>
            <div className={b('date-input')}>
              <InputDate showTimeSelect selected={date.endDate} onChange={onChangeEndDate} />
            </div>
          </div>
        </div>
      </div>

      <div className={b('bottom')}>
        <div className={b('inputs')}>
          <div className={b('input')}>
            <div className={b('title')}>{locale.searchIn}</div>
            <Select name="role" items={searchInItems} activeItem={filters.role} onChange={handleSearchInChange} />
          </div>

          <div className={b('input')}>
            <div className={b('title')}>{locale.agent}</div>
            <SearchUserInput
              filterValue={filterValue}
              handleSearchChange={handleSearchChange}
              placeholder={`${locale.search} ${locale.user}`}
              locale={locale}
              isLoadingSearchResult={isLoadingSearchResult}
              searchResult={searchResult}
              handleResultClick={onResultClick}
            />
          </div>
        </div>

        <div className={b('checkboxes')}>
          <div className={b('checkbox')}>
            <CheckBox checked={isDirectOnly} onChange={() => setIsDirectOnly(!isDirectOnly)} name="isDirectOnly" />
            <p className={b('checkbox-title')}>{locale.directOnly}</p>
          </div>
          <div className={b('checkbox')}>
            <CheckBox checked={isHigher} onChange={() => setIsHigher(!isHigher)} name="isHigher" />
            <p className={b('checkbox-title')}>{locale.higher}</p>
          </div>
          <div className={b('checkbox')}>
            <CheckBox checked={isDeposit} onChange={() => setIsDeposit(!isDeposit)} name="isDeposit" />
            <p className={b('checkbox-title')}>{locale.toDeposit}</p>
          </div>
          <div className={b('checkbox')}>
            <CheckBox checked={isWithdrawal} onChange={() => setIsWithdrawal(!isWithdrawal)} name="isWithdrawal" />
            <p className={b('checkbox-title')}>{locale.retirement}</p>
          </div>
          <div className={b('checkbox')}>
            <CheckBox checked={isBonus} onChange={() => setIsBonus(!isBonus)} name="isBonus" />
            <p className={b('checkbox-title')}>{locale.bonus}</p>
          </div>
        </div>

        <div className={b('button')}>
          <Button size="low" text={locale.acceptFilter} type="submit" />
        </div>
      </div>
    </form>
  );
};

export default FilterBlock;
